module.exports = __webpack_public_path__ + "static/media/bg.9cc084c3.svg";